import { Box, Icon } from '@livable/saas-react-components';
import { Button, Container, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PreviewCycleChargesModal from 'src/components/allocations/PreviewCycleChargesModal';
import useStyles from './styles';
const AllocationsActionBar = observer(_ref => {
  let disabled = _ref.disabled,
    handleAddAdditionalCycle = _ref.handleAddAdditionalCycle,
    propertyId = _ref.propertyId;
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.boxWrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.actionsWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10,
    className: classes.actionBar
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleAddAdditionalCycle(),
    variant: "action",
    'custom-attribute': '497-AllocationsActionBar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), t('allocations.add_custom_table'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(PreviewCycleChargesModal, {
    disabled: disabled
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => navigate("/edit_property?id=".concat(propertyId)),
    variant: "action",
    'custom-attribute': '498-AllocationsActionBar'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "settings"
  }), t('allocations.edit_property_details')))))));
});
export default AllocationsActionBar;